import React, { useRef, useEffect } from 'react';
import { Box, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100vh',
  },
  page: {
    width: '210mm',
    height: '297mm',
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'auto',
    boxSizing: 'border-box',
  },
}));

const PageViewer = ({ componentRef }) => {
  const classes = useStyles();
  const containerRef = useRef(null);

  useEffect(() => {
    console.log('Container Height:', containerRef.current?.clientHeight);
  }, []);

  const pageCount = Math.ceil(containerRef.current?.clientHeight / 297);

  console.log('Page Count:', pageCount);

  return (
    <>
      <Box ref={containerRef} className={classes.pageContainer}>
        Hi
        <Box style={{paddingTop:1000}}>
          Hi
        </Box>
        <Box style={{paddingTop:1000}}>
          Hi
        </Box>
      </Box>
    </>
  );
};


export default PageViewer;
